import GamePlayers from "../../../../common/components/add-payer-component/GamePlayers";
import React, { Dispatch, SetStateAction } from "react";
import ConfigScreen from "../../../../common/components/game-screens/ConfigScreen";
import { useTranslation } from "react-i18next";
import { IInterestingDiscussionGameConfig } from "../../../../common/types";

interface Props {
    moveBack: () => void;
    moveForward: () => void;
    config: IInterestingDiscussionGameConfig;
    changeConfig: Dispatch<SetStateAction<IInterestingDiscussionGameConfig>>;
}
const PlayersSelection = ({ moveBack, moveForward, config, changeConfig }: Props) => {
  
    const MIN_PLAYERS = 2;
    const { t } = useTranslation();
    const minNumStart = t('games.buttons.btnCaption.minNum.start');
    const minNumEnd = t('games.buttons.btnCaption.minNum.end');
    const note = config.selectedPlayerIds.length < MIN_PLAYERS ? `${minNumStart}${MIN_PLAYERS}${minNumEnd}` : undefined;

    const onPlayersSelectionChange = (ids: string[]) => {
        changeConfig((prevConfig) => ({
            ...prevConfig,
            selectedPlayerIds: ids,
        }));
    }
  
    return <ConfigScreen
          configTitlePath="games.interview.settings.title"
          actionButtonsNote={note}
          backToDetails={moveBack}
          nextButtonLabelPath="games.buttons.play"
          nextToPlay={moveForward}
          nextActionDisabled={config.selectedPlayerIds.length < MIN_PLAYERS}
        >
          <GamePlayers
            onPlayersSelectionChange={onPlayersSelectionChange}
            selectedPlayerIds={config.selectedPlayerIds}
          />
        </ConfigScreen>
};

export default PlayersSelection
